// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseSetupDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';

const ROOT_URL = 'databaseSetup/';

export default {
  getSupportedDatabaseType() {
    return fetch(`${ROOT_URL}SupportedDatabaseType`).get();
  },

  testConnection(serverType, connectionString) {
    return fetch(`${ROOT_URL}TestConnection`).post({ ServerTypeId: serverType, ConnectionString: connectionString });
  },

  setupDatabase(serverType, connectionString) {
    return fetch(`${ROOT_URL}DatabaseInfo`).post({ ServerTypeId: serverType, ConnectionString: connectionString });
  },

  getConnectionInfo() {
    return fetch(`${ROOT_URL}DatabaseInfo`).get();
  },

  provisionStaticData() {
    return fetch(`${ROOT_URL}provisionStaticData`).post();
  },

  provisionStaticDataStatus() {
    return fetch(`${ROOT_URL}provisionStaticDataStatus`).get();
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.DatabaseSetupDataFetcher.js